/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import i18next from 'i18next';

import { MOMENT_LOCALES, DATE_FORMATS } from '../constants/time';

const moment = require('moment');

const I18N_NESTING_KEY_SEPARATOR = '$';
export const NAMESPACE = 'messages';
const FALLBACK_LANGUAGE = 'en';

let i18nInstance = i18next.createInstance();

export function setupI18n(aWindow: Window) {
  const { locale, localeData } = aWindow.__INITIAL_I18N__ ?? { locale: FALLBACK_LANGUAGE };
  delete aWindow.__INITIAL_I18N__;
  initialize(locale, localeData);
  return i18nInstance;
}

export const setInstance = (instance: i18next.i18n) => (i18nInstance = instance);

export const getInstance = () => i18nInstance;

export const initialize = (language: string, localeData: object) =>
  i18nInstance.init(createConfig(language, localeData));

export const translate = (key: any, options?: any) => getInstance().t(key, options);

function formatValue(value: string, format?: string, language?: string) {
  if (!language || !format) {
    return value;
  }

  if (format === 'date') {
    return moment(value).locale(MOMENT_LOCALES[language]).format(DATE_FORMATS[language]);
  }

  if (format === 'fullDate') {
    return moment(value).locale(MOMENT_LOCALES[language]).format('ll');
  }

  return value;
}

export const createConfig = (language?: string, localeData?: object) => {
  const lng = language || FALLBACK_LANGUAGE;

  return _.assign(
    {
      lng,
      fallbackLng: FALLBACK_LANGUAGE,
      ns: NAMESPACE,
      fallbackNS: NAMESPACE,
      keySeparator: I18N_NESTING_KEY_SEPARATOR,
      interpolation: {
        escapeValue: false,
        format: formatValue,
      },
    },
    localeData ? { resources: { [lng]: { [NAMESPACE]: localeData } } } : {},
  );
};

export const getLanguage = () => getInstance().language;
